import RouteWithAuth from './RouteWithAuth'

export default RouteWithAuth



// WEBPACK FOOTER //
// ./src/components/RouteWithAuth/index.js